export default __webpack_public_path__ + "static/media/microsoft-sql-server.d4f90b22.png";